import { calendarBarColors } from '@constants/calendar';
import React, { Dispatch, SetStateAction } from 'react';
import { AdminUser } from '../../types/shared/AdminUser';

const SidebarAdminRowItem: React.FC<SidebarAdminRowProps> = ({
    admin,
    adminList,
    ellipsis,
    isSubItem,
    color,
    setTooltipContent,
}) => {
    const initials = `${admin.firstName.slice(0, 1)}${admin.lastName.slice(0, 1)}`;

    const fullNameContent = `${admin.firstName} ${admin.lastName}`;
    const fullListContent = adminList.map((admin, i) => `${admin.firstName} ${admin.lastName}`);

    const subItemStyle = {
        backgroundColor: color || calendarBarColors.workshop,
    };

    return (
        <>
            <span
                className={`admin-row-item ${isSubItem ? 'sub-item' : ''}`}
                onMouseOver={() =>
                    setTooltipContent(ellipsis ? fullListContent : [fullNameContent])
                }
                onMouseLeave={() => setTooltipContent([])}
                style={isSubItem ? subItemStyle : {}}
            >
                {!ellipsis ? initials : '...'}
            </span>
        </>
    );
};

interface SidebarAdminRowProps {
    admin: AdminUser;
    adminList: AdminUser[];
    ellipsis?: boolean;
    isSubItem?: boolean;
    color?: string;
    setTooltipContent: Dispatch<SetStateAction<string[]>>;
}

export default SidebarAdminRowItem;
